import { createSlice } from "@reduxjs/toolkit";

export const uiStates = createSlice({
  name: "uiStates",
  initialState: {
    walletModal: false,
  },
  reducers: {
    showWalletModal: (state, action) => {
      state.walletModal = true;
    },
    hideWalletModal: (state, action) => {
      state.walletModal = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { showWalletModal, hideWalletModal } = uiStates.actions;

export default uiStates.reducer;
